import type { ArrowDirection } from '../components/atomic/buttons/arrows/Arrows';
import {
  closeInfoPopup,
  toggleInfoPopup,
} from '../shared/infoPopup/infoPopupControllerActions';
import { nextPageForDirection } from '../shared/pagination/clampPageChange';
import {
  MAX_LEVEL_PAGE,
  type PlayerLevelScreenModel,
} from './PlayerLevelScreenModelScreen';

export class PlayerLevelScreenController {
  constructor(private readonly model: PlayerLevelScreenModel) {}

  handleNavigate = (direction: ArrowDirection) => {
    this.model.setPage((current) =>
      nextPageForDirection(direction, current, MAX_LEVEL_PAGE),
    );
    this.model.onNavigate?.(direction);
  };

  handleInfoButtonClick = () => {
    toggleInfoPopup(this.model);
  };

  handleInfoClose = () => {
    closeInfoPopup(this.model);
  };

  handleGoBack = () => {
    this.model.onGoBack?.();
  };
}
